const metrics = [
  { value: '2,000+', label: 'Enterprises Supported Globally' },
  { value: '$54M', label: 'In Professional Support Delivered' },
  { value: '110', label: 'Countries in Our Community' },
];

export const PartnerLandingTrustedBySection = () => (
  <section className='bg-white py-16 sm:py-20 px-4'>
    <div className='max-w-[1216px] mx-auto text-center'>
      <h2 className='mb-10 text-3xl sm:text-4xl font-medium leading-11 tracking-[-0.72px] text-gray-600 sm:mb-12'>
        Trusted by Social Enterprises Around the World
      </h2>
      <div className='grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12'>
        {metrics.map(({ value, label }) => (
          <div key={label} className='flex flex-col items-center'>
            <div className='text-4xl sm:text-display-xl font-semibold leading-12 sm:leading-[4.5rem] tracking-[-0.8px] sm:tracking-[-1.2px] text-brand-500'>
              {value}
            </div>
            <div className='mt-2 text-base sm:text-lg font-semibold leading-6 sm:leading-7 text-gray-600'>
              {label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
